import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@fontsource-variable/archivo";
import "@fontsource-variable/hanken-grotesk";
import "@/index.css";
import App from "@/App";

const root = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

const KNOWN = ["/", "/opportunity", "/investment-support", "/process", "/contact", "/privacy-policy", "/terms-of-use", "/thank-you"];
const path = window.location.pathname.replace(/\/+$/, "") || "/";
const expected = KNOWN.includes(path) ? path : "404";

if (process.env.NODE_ENV === "production" && root.hasChildNodes() && root.dataset.route === expected) {
  const hydrate = () => ReactDOM.hydrateRoot(root, tree);
  if ("requestIdleCallback" in window) window.requestIdleCallback(hydrate, { timeout: 2000 });
  else setTimeout(hydrate, 1);
} else {
  root.textContent = "";
  ReactDOM.createRoot(root).render(tree);
}
